// extracted by mini-css-extract-plugin
export default {"melodyVideo":"kN-z","isFullWidth":"lN-z","landingPageVideo":"mN-z","play":"nN-z","iframeVideo":"oN-z","playHidden":"pN-z","fullwidth":"qN-z"};